import { getText } from 'i18n/intl';
import { type SyncSettingResponse } from '@timeedit/calendar-integration-api-contract';
import { Form, type FormInstance, Select } from '@timeedit/ui-components/antd';
import {
  type ReminderFields,
  type ReminderUiValue,
  reminderFieldsToUiValue,
  reminderOptions,
  uiValueToReminderFields,
} from './reminderOptions';

const intlPrefix = 'integration.calendar.sync_settings.form.reminder';

type Props = {
  form: FormInstance<SyncSettingResponse>;
  onChange: (fields: ReminderFields) => void;
};

const ReminderSelect = ({ form, onChange }: Props) => (
  <Form.Item
    label={getText(`${intlPrefix}.label`)}
    tooltip={getText(`${intlPrefix}.description`)}
    shouldUpdate={hasReminderChanged}
  >
    {() => {
      const reminder = form.getFieldValue(['syncMode', 'reminder']) as
        | ReminderFields
        | undefined;

      return (
        <Select
          options={reminderOptions}
          size="small"
          value={reminderFieldsToUiValue(reminder)}
          onChange={(uiValue: ReminderUiValue) =>
            onChange(uiValueToReminderFields(uiValue))
          }
        />
      );
    }}
  </Form.Item>
);

export default ReminderSelect;

function hasReminderChanged(
  prev: SyncSettingResponse,
  curr: SyncSettingResponse
): boolean {
  const prevReminder = (
    prev.syncMode as { reminder?: ReminderFields } | undefined
  )?.reminder;
  const currReminder = (
    curr.syncMode as { reminder?: ReminderFields } | undefined
  )?.reminder;
  return (
    prevReminder?.behavior !== currReminder?.behavior ||
    prevReminder?.minutesBeforeStart !== currReminder?.minutesBeforeStart
  );
}
